import { ReactTFC } from "../../../utils/fp/missing-ts-parts";

import { css } from "@emotion/react";

import { SegmentIconSvg } from "./segment-icons";
import React from "react";
import { DealerLocatorSegment } from "@swo/storefront";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { fontColor, FONTS, fontSize } from "../../../styles/fonts";
import { DealerDto } from "@swo/salesforce-service";

export const SegmentIconWithLabel: ReactTFC<{
  segment: DealerDto["segment"];
  cropped: boolean;
  translations: {
    birdingLabel: string;
    huntingLabel: string;
    outdoorLabel: string;
  };
}> = props => {
  function translated(segment: NonNullable<DealerDto["segment"]>): string {
    switch (segment) {
      case "birding": {
        return props.translations.birdingLabel;
      }
      case "hunting": {
        return props.translations.huntingLabel;
      }
      case "outdoor": {
        return props.translations.outdoorLabel;
      }
      default: {
        const _: never = segment;

        return _;
      }
    }
  }

  return props.segment ? (
    <span
      css={[
        FONTS.SwarovskiFutura300,
        fontColor.black,
        fontSize.x2,
        css`
          text-transform: uppercase;
          margin-right: 5px;

          display: flex;
          align-items: center;
        `,
      ]}
    >
      <SegmentIconSvg
        segment={props.segment}
        cropped={true}
        css={css`
          width: 32px;
          margin-right: 8px;
          margin-top: -6px;

          color: ${CSS_COLORS.Green};
        `}
      />
      <span>{translated(props.segment)}</span>
    </span>
  ) : null;
};
